import pagination from '@iso/lib/helpers/pagination';

const {
    actions: baseActions,
    types,
    reducer,
} = pagination('orderStatusTypes');

const actions = {
    requestFetchOrderStatusTypes: baseActions.request,
    fetchOrderStatusTypesSucceeded: baseActions.succeeded,
    fetchOrderStatusTypesFailed: baseActions.failed,
};

export { types, actions };

export default reducer;